var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamAllocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.3,300c92,0,166.7,74.6,166.7,166.7v200H166.7v-200C166.7,374.6,241.3,300,333.3,300z M109.6,400.2 c-5.3,17.9-8.4,36.4-9.3,55l-0.3,11.5v200H0v-150c0-59.5,44.8-109.5,104-116L109.6,400.2L109.6,400.2z M557.1,400.2 c61.6,3.8,109.6,54.8,109.6,116.5v150h-100v-200C566.7,443.6,563.3,421.3,557.1,400.2z M116.7,200c46,0,83.3,37.3,83.3,83.3 s-37.3,83.3-83.3,83.3s-83.3-37.3-83.3-83.3S70.6,200,116.7,200z M550,200c46,0,83.3,37.3,83.3,83.3S596,366.7,550,366.7 s-83.3-37.3-83.3-83.3S504,200,550,200z M333.3,0C407,0,466.7,59.7,466.7,133.3S407,266.7,333.3,266.7S200,207,200,133.3 S259.7,0,333.3,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAllocationIcon);
export default __webpack_public_path__ + "static/media/team_allocation_icon.a788e852c42b55be7639723a94849e37.svg";
export { ForwardRef as ReactComponent };